import React from 'react'
import useWindowScroll from 'react-use/lib/useWindowScroll'

const ScrollY = ({ children }) => {
  const { y: pageOffset } = useWindowScroll()

  return <>{children(pageOffset)}</>
}

export default ScrollY
